import React from "react";
import Layout from "../form-layout";

// Shown when a patient selects "Yes, but I am no longer using it" at the router.
// Form C (previous GLP-1 users) isn't designed yet.
export default function FormCPlaceholder({ onBack, goToStep }) {
  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-lg font-semibold text-center mb-3">This pathway isn't available yet</h2>
      <p className="text-sm text-gray-700 text-center mb-6">
        We're still setting up the assessment for patients who have previously used a GLP-1 weight-loss
        medication. Please check back soon, or get in touch with our team and we'll help you directly.
      </p>
      <p className="text-sm text-center text-gray-700">
        Contact us at{" "}
        <a href="mailto:contact@slimmingdoctor.co.uk" className="text-[#35C3D9] font-semibold">
          contact@slimmingdoctor.co.uk
        </a>
      </p>
    </Layout>
  );
}
